import { render, staticRenderFns } from "./DirectSelling.vue?vue&type=template&id=3f56ce98&scoped=true"
import script from "./DirectSelling.vue?vue&type=script&lang=js"
export * from "./DirectSelling.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DirectSelling.vue?vue&type=style&index=1&id=3f56ce98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56ce98",
  null
  
)

export default component.exports